export const DEFAULT_CONFIG = {
    name: '',
    chat_model: '',
    temperature: 0.7,
    top_k: 4,
    top_k_notes: 1,
    top_k_module_docs: 3,
    top_k_submodule_docs: 3,
    max_response_tokens: 2048,
    planner_confidence_threshold: 0.65,
    synth_tokens_threshold: 4500,
    synth_sources_threshold: 7,
    synth_docs_threshold: 8,
    synth_subqueries_threshold: 10
};

export const VALIDATION_MESSAGES = {
    REQUIRED_FIELDS: 'Заповніть обовязкові поля',
    CONFIG_CREATED: 'Конфігурацію успішно створено',
    CONFIG_UPDATED: 'Конфігурацію успішно оновлено',
    CONFIG_DELETED: 'Конфігурацію успішно видалено',
    CREATE_ERROR: 'Помилка створення конфігурації',
    UPDATE_ERROR: 'Помилка оновлення конфігурації',
    DELETE_ERROR: 'Помилка видалення конфігурації',
    LOAD_ERROR: 'Не вдалося завантажити конфігурації агентів',
    CANNOT_DELETE_DEFAULT: 'Неможливо видалити конфігурацію за замовчуванням'
};

export const GRID_CONFIG = {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [5, 10, 20],
    HEIGHT: 'auto'
};
